<template>
  <!-- <main class="max-w-[1440px] mx-auto px-12 py-12 space-y-12"> -->

  <!-- KPIs -->
  <section class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
    <div v-for="kpi in kpis" :key="kpi.label"
      class="bg-white p-10 rounded-3xl premium-shadow border border-slate-50 flex flex-col justify-between min-h-[220px]">
      <div>
        <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
          {{ kpi.label }}
        </p>
        <h2 class="text-6xl font-black tracking-tighter">
          {{ kpi.value }}
          <span v-if="kpi.suffix" class="text-2xl opacity-30">{{ kpi.suffix }}</span>
        </h2>
      </div>

      <div v-if="kpi.trend"
        class="flex items-center gap-2 text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full text-xs font-bold w-fit">
        <i class='bx bx-trending-up text-sm'></i>
        {{ kpi.trend }}
      </div>

      <div v-if="kpi.progress !== undefined" class="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden">
        <div class="bg-slate-900 h-full" :style="{ width: kpi.progress + '%' }"></div>
      </div>
    </div>
  </section>

  <!-- Invite Link Card -->
  <section class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50
            flex flex-col md:flex-row md:items-center md:justify-between gap-6">

    <!-- Left -->
    <div>
      <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
        Your Invite Link
      </p>
      <p class="mt-2 text-sm font-mono text-slate-700 break-all">
        {{ inviteLink }}
      </p>
      <p class="mt-2 text-xs text-slate-400" style="font-weight: 700;">
        Share this link to build your verified ownership base and unlock brand opportunities. 
      </p>
    </div>

    <!-- Right -->
    <button @click="copyInviteLink" class="bg-primary text-white font-bold px-8 py-4 rounded-xl
                flex items-center gap-2 text-xs uppercase tracking-wider
                hover:opacity-90 transition-all w-fit">
                <i class='bx bx-copy text-sm'></i>
      Copy Link
    </button>

  </section>


  <!-- Intelligence + Activity -->
  <section class="grid grid-cols-1 lg:grid-cols-12 gap-12">

    <!-- LEFT -->
    <div class="lg:col-span-12 space-y-12">
      <div class="flex items-end justify-between">
        <div>
          <h3 class="text-3xl font-bold">Audience Intelligence</h3>
          <p class="text-slate-400">
            Deep behavioral mapping of your verified ownership base.
          </p>
        </div>
        <!-- <button class="text-xs font-bold border-b-2 border-slate-900 uppercase tracking-wider">
          Export Data →
        </button> -->
      </div>

      <div>
        <!-- Growth -->
        <div class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50">
          <h4 class="font-bold mb-6">Growth Over Time</h4>
          <div class="chart-box">
            <div id="audienceGrowthChart"></div>
          </div>

        </div>
      </div>


    </div>

  </section>

</template>

<script>
  import ApexCharts from "apexcharts";
  import { useToast } from "vue-toastification";
  import { mainBaseUrl } from "../apis/appconst";
  import { loadInfluencerDashboardApi } from "../apis/influencerapis";

  export default {
    name: "DashboardScreen",

    data() {
      return {
        isLoading:false,
      
        toast: null,
        growthChart: null,

        inviteLink: "join/creator123",

        contributorStats: {
          architects: 18
        },

        fanColors: [
          { bg: "bg-pastel-blue", icon: "text-blue-600" },
          { bg: "bg-pastel-purple", icon: "text-purple-600" },
          { bg: "bg-pastel-green", icon: "text-emerald-600" },
          { bg: "bg-pastel-amber", icon: "text-amber-600" }
        ],

        plan: {
          name: "PRO",
          renewal: "Jan 12",
          coverage: "Standard Node Protection"
        },

        user: {
          avatar: "https://i.pravatar.cc/100"
        },

        kpis: [
          {
            label: "Insured Fans",
            value: "0",
            trend: ""
          },
          {
            label: "Verified Fans",
            value: "0"
          },
          {
            label: "Avg Fan Quality",
            value: "0",
            suffix: "%",
            progress: 0
          },
          {
            label: "Campaigns",
            value: "0",
            suffix: "%",
            progress: 0
          }
        ],

        profileCompletion: 72,

        fans: [],

      };
    },

    async mounted() {

      this.toast = useToast();

      // ✅ Invite link base
      

      const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

      if (!ldata || !ldata.user_id) {
        window.location.href = "/login";
        return;
      }
      this.inviteLink = mainBaseUrl + "join/"+ldata.ven_dt.inf_username;
      await this.loadDashboard(ldata.user_id);
    },

    methods: {
     
      
      initDonut() {

        const el = document.querySelector("#audienceDonutChart");
        if (!el) return;

        if (this.donutChart) {
          this.donutChart.destroy();
        }

        this.donutChart = new ApexCharts(el, {

          chart: {
            type: "donut",
            height: 128,
            width: 128
          },

          series: [
            this.profileCompletion,
            100 - this.profileCompletion
          ],

          legend: { show: false },

          dataLabels: { enabled: false },

          stroke: { width: 0 },

          plotOptions: {
            pie: {
              donut: {
                size: "72%"
              }
            }
          },

          colors: ["#0f172a", "#e2e8f0"]
        });

        this.donutChart.render();
      }

      ,
      initGrowthChart(growth) {

        const el = document.querySelector("#audienceGrowthChart");
        if (!el) return;

        if (this.growthChart) {
          this.growthChart.destroy();
        }

        this.growthChart = new ApexCharts(el, {

          chart: {
            type: "line",
            height: 220,
            toolbar: { show: false }
          },

          stroke: {
            curve: "smooth",
            width: 3
          },

          series: [{
            name: "Audience",
            data: growth?.data || []
          }],

          xaxis: {
            categories: growth?.labels || []
          },

          colors: ["#0f172a"],

          grid: {
            strokeDashArray: 4
          }
        });

        this.growthChart.render();
      }
      ,
      // ======================================================
      // ✅ LOAD DASHBOARD FROM API
      // ======================================================
      async loadDashboard(user_id) {

        const res = await loadInfluencerDashboardApi(user_id);

        if (!res.status) {
          this.toast.error("Dashboard load failed");
          return;
        }

        // ================= KPIs =================
        this.kpis = res.kpis || [];


        // ================= Completion =================
        this.profileCompletion = res.profile?.completion || 0;

        // ================= Recent Fans =================
        this.fans = (res.recent_fans || []).map(f => ({
          id: f.follower_id,
          name: f.follower_name || ("Fan #" + f.follower_id),
          time: "recent"
        }));

        // ================= Charts =================
        this.initGrowthChart(res.growth);
        this.initDonut();
      }
      ,

      // ======================================================
      // ✅ COPY LINK
      // ======================================================
      copyInviteLink() {

        navigator.clipboard.writeText(this.inviteLink);

        this.toast.success("Invite link copied!", {
          timeout: 2000,
          closeOnClick: true
        });
      }
    }
  };
</script>
<style scoped>
  .chart-box {
    width: 100%;
    overflow: hidden;
    /* prevents bleeding */
  }

  #audienceGrowthChart {
    width: 100%;
  }

  .card {
    overflow: hidden;
    /* VERY IMPORTANT */
  }

  .donut-center {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 18px;
  }
  .input-field {
  width: 100%;
  background: #f8fafc;              /* matches slate-50 */
  border-radius: 16px;
  padding: 14px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  border: 1px solid transparent;
  transition: all 0.25s ease;
}

.input-field::placeholder {
  color: #94a3b8;                   /* slate-400 */
  font-weight: 500;
}

.input-field:focus {
  outline: none;
  border-color: #0f172a;
  background: white;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
}

.file-input {
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.file-input::file-selector-button {
  background: #0f172a;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  margin-right: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.file-input::file-selector-button:hover {
  opacity: 0.85;
}
.poll-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dynamic-field {
  animation: fadeSlide 0.25s ease;
}

@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>